import * as React from 'react';
import Typography from '@mui/material/Typography';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import Stack from '@mui/material/Stack';

export default function CustomDatePicker() {
  const today = new Date().toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  });

  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      <CalendarTodayRoundedIcon fontSize="small" sx={{ color: 'text.secondary' }} />
      <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
        {today}
      </Typography>
    </Stack>
  );
}
